<template>
  <div class="notification-template-editor">
    <EditorHtml
      title="Mensagem"
      field="template"
      :required="false"
      :value="value"
      @input="$emit('input', $event)"
      :changed="() => {}"
    />
    <div class="notification-template-editor-footer">
      <small class="notification-template-editor-params" @click="$emit('open-params')">
        <i class="fa-solid fa-bracket-curly"></i>
        <i class="fa-solid fa-bracket-curly"></i>
        Parâmetros
        <i class="fa-solid fa-bracket-curly-right"></i>
        <i class="fa-solid fa-bracket-curly-right"></i>
      </small>
      <Button
        _key="btnSave"
        type="success"
        title="Salvar"
        classIcon="fas fa-save"
        size="small"
        :loading="isLoading('btnSave')"
        :clicked="onSave"
      />
    </div>
  </div>
</template>

<script>
import EditorHtml from "@/ui/forms/EditorHtml";
import Button from "@/ui/forms/Button";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "NotificationTemplateEditor",
  components: { EditorHtml, Button },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters("generic", ["isLoading"]),
  },
  methods: {
    ...mapMutations("generic", ["addLoading"]),
    onSave() {
      this.addLoading("btnSave");
      this.$emit("save");
    },
  },
};
</script>

<style scoped>
.notification-template-editor {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.notification-template-editor-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.notification-template-editor-params {
  font-size: 13px;
  color: var(--color-brand);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.notification-template-editor-params:hover {
  text-decoration: underline;
}
</style>

<style>
.dark-theme .notification-template-editor-params {
  color: #e6edf3;
}
</style>
